import React from 'react'
import { useWizard, useOnboarding } from '../context'
import { OptionCard } from './OptionCard'

export const MultipleAnswer = ({
  className,
  question,
  surveyKey: key,
  icon,
  text,
  value
}) => {
  const { setIsNextDisabled } = useWizard()
  const { state, updateState } = useOnboarding()
  const { isSelected, index } = React.useMemo(() => {
    const response = { isSelected: false, index: -1 }

    if (state.survey[key]) {
      const index = state.survey[key].findIndex(
        ({ value: savedValue }) => savedValue === value
      )
      response.isSelected = index !== -1
      response.index = index
    }

    return response
  }, [state, key, value])
  const shouldProceed = React.useCallback(
    () => state.survey[key] && state.survey[key].length > 0,
    [state, key]
  )

  React.useEffect(() => {
    setIsNextDisabled(() => !shouldProceed())
  }, [])

  function handleSelection() {
    const survey = state.survey

    if (isSelected) {
      survey[key].splice(index, 1)
      if (survey[key].length === 0) delete survey[key]
    } else {
      const response = { question: question, label: text, value: value }

      if (!survey[key]) survey[key] = [response]
      else survey[key].push(response)
    }

    updateState({ survey })
    setIsNextDisabled(() => !shouldProceed())
  }

  return (
    <OptionCard
      className={className}
      icon={icon}
      text={text}
      isSelected={isSelected}
      onSelection={handleSelection}
    />
  )
}
